import Component, { mixins } from "vue-class-component"

import HttpStatusCode from 'http-status-codes'

import ROUTES from "@/router/ROUTES"

import { AxiosError } from "axios"

@Component
export default class BaseService extends mixins() {
  protected service_base_defaultErrorHandler(error: AxiosError, reject: any): void {
    let status: string = HttpStatusCode.INTERNAL_SERVER_ERROR.toString()

    if (error.response) {
      status = error.response?.status.toString()
    }

    this.mixin_router_navigate({
      name: ROUTES.ERROR,
      params: {
        status
      }
    })

    reject(error)
  }

  protected service_base_generateQueryFromObject(query: object): string {
    try {
      let queryString: string = ''

      Object.entries(query)
        .forEach(([key, value]: any) => {
          if (queryString.length > 0) {
            queryString += '&'
          }
          
          queryString += `${key}=${value}`
        })

      return queryString
    } catch (exception) {
      return ''
    }
  }

  protected service_baseService_multipartFormDataHeader(): object {
    return {
      'Content-Type': 'multipart/form-data'
    }
  }
}